import cn from '@/utils/cn';

import type { PropsWithChildren, ReactNode } from 'react';

export interface PanelProps {
  startElement?: ReactNode;
  endElement?: ReactNode;
  className?: string;
}

function Panel({
  startElement,
  children,
  endElement,
  className,
}: PropsWithChildren<PanelProps>) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-xl bg-white p-3.5 shadow-[0px_3px_20px_0px_rgba(0,0,0,0.05)] lg:gap-2.5',
        className
      )}
    >
      {startElement && <div className="shrink-0">{startElement}</div>}
      <div className="font-jakarta font-semibold">{children}</div>
      {endElement && <div className="ml-auto shrink-0">{endElement}</div>}
    </div>
  );
}

export default Panel;
